module.exports = __webpack_public_path__ + "img/home.c47ed9ec.svg";